import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '../../../hooks/useTheme';

interface AuthLayoutProps {}

const AuthLayout: React.FC<AuthLayoutProps> = () => {
  const {isMobile} = useTheme();

  return (
    <div className="min-h-screen py-[18px] bg-cover bg-center flex flex-col items-stretch" style={{ backgroundImage: "url('/images/login_background.jpg')" }}>
      <div className={`h-full flex flex-col items-center flex-1 ${isMobile ? 'gap-8' : 'justify-between'}`}>
        <div className="flex items-center justify-center gap-2">
          <img src="/images/logo_text_white.svg" alt="Club Orange Logo" className="h-14" />
        </div>

        <div className="max-w-[440px] w-full mx-4 p-6 bg-[#1A1A1A] border-4 border-white rounded-3xl flex items-center justify-center">
          <Outlet />
        </div>

        <div>{/* Spacer */}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
